import { get } from 'lodash';
import _ from 'lodash';
import { createSelector } from 'reselect';

import { CreateEditTruckRouteScheduleEnum } from 'Common/FieldEnum';
import { TruckRouteTypeEnum } from 'Common/Constants/Enumeration/TruckRouteEnum';

const root = state =>
  get(state, 'TruckRouteState.createEditTruckRouteSchedule');

export const getTruckRouteList = state =>
  get(root(state), 'truckRouteListData', []);
export const getTruckRouteListDataLoading = state =>
  get(root(state), 'truckRouteListDataLoading', false);
export const getTruckRouteListDataLoadingError = state =>
  get(root(state), 'truckRouteListDataLoadingError', null);
export const getTruckRouteScheduleDetailData = state =>
  get(root(state), 'truckRouteScheduleDetailData', null);
export const getTruckRouteScheduleDetailLoading = state =>
  get(root(state), 'truckRouteScheduleDetailLoading', false);
export const getTruckRouteScheduleDetailError = state =>
  get(root(state), 'truckRouteScheduleDetailError', null);
export const getSaveLoading = state =>
  get(root(state), 'saveRouteScheduleLoading', false);
export const getSaveLoadingError = state => get(root(state), 'saveError', null);
export const getSaveData = state => get(root(state), 'savedRouteSchedule', '');

export const getRoutes = createSelector(getTruckRouteList, truckRoutes => {
  return truckRoutes.map(truckRoute => ({
    ...truckRoute,
    [CreateEditTruckRouteScheduleEnum.Type]:
      truckRoute[CreateEditTruckRouteScheduleEnum.Type] ===
      TruckRouteTypeEnum.Pickup
        ? 'Pickup'
        : truckRoute[CreateEditTruckRouteScheduleEnum.Type] ===
          TruckRouteTypeEnum.Delivery
          ? 'Delivery'
          : '',
  }));
});

export const getSortedRouteIds = createSelector(
  getRoutes,
  getTruckRouteScheduleDetailData,
  (items, selectedTruckRoute) => {
    if (
      selectedTruckRoute &&
      selectedTruckRoute[CreateEditTruckRouteScheduleEnum.Id]
    ) {
      const cloneItems = _.clone(items);
      const removedData = _.remove(cloneItems, item => {
        return Boolean(
          _.find(
            selectedTruckRoute[CreateEditTruckRouteScheduleEnum.RouteIds],
            routeId => {
              return item.Id === routeId;
            }
          )
        );
      });
      let sortedData;
      if (removedData.length) {
        sortedData = _.concat(removedData, cloneItems);
      }
      return sortedData;
    } else {
      return items;
    }
  }
);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/createedittruckrouteschedule/selectors.js